export default __webpack_public_path__ + "static/media/aerospace.b28a1f91.jpeg";